<template>
    <section class="gallery-section">
        <div class="section-header">
            <p class="section-kicker">Media Gallery</p>
            <h2 class="section-title">Featured highlights</h2>
            <p class="section-copy">
                Explore our collection of photos, videos, and event highlights showcasing life at Lagos Lawn Tennis Club.
            </p>
        </div>

        <div class="cards">
            <GalleryCard
                v-for="(card, index) in dataList"
                :key="index"
                :title="card.title"
                :content="card.description.length > 150 ? card.description.substring(0, 150) + '...' : card.description"
                :image="card.image"
                :date="card.date"
                @click="openDetails(card)"
            />
        </div>

        <button
            v-if="dataList.length > 6"
            type="button"
            class="view-more"
            @click="viewMore"
        >
            <span>View more</span>
            <i class="fa fa-arrow-right"></i>
        </button>
    </section>
</template>

<script setup>
import GalleryCard from "./CommonCard/GalleryCard.vue";
import axios from "axios";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

let base_url = process.env.VUE_APP_BASE_LIVE_URL;
const dataList = ref([]);

onMounted(async () => {
  await listGallery();
});

const listGallery = async () => {
  try {
    const response = await axios.get("/media_gallery_list_six.php");

    dataList.value = response.data.data.map((data) => ({
      title: data.title,
      description: data.description,
      date: data.date,
      image: `${base_url}/${data.banner_image}`
    }));
  } catch (error) {
    console.error(error.message);
  }
};

const viewMore = () => {
    router.push("/all-media");
};

const openDetails = (card) => {
  router.push({
    name: "MediaGalleryPage",
    params: {
      title: card.title
    }
  });
};
</script>

<style scoped lang="scss">
.gallery-section {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 24px;
}

.section-header {
    margin-bottom: 24px;
}

.section-kicker {
    margin: 0 0 8px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-title {
    margin: 0;
    font-size: clamp(30px, 3vw, 44px);
    line-height: 1.08;
    font-weight: 700;
    color: #0f172a;
}

.section-copy {
    margin: 10px 0 0;
    max-width: 760px;
    color: #64748b;
    font-size: 16px;
    line-height: 1.7;
}

.cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;
}

.view-more {
    margin-top: 24px;
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #dbe4ec;
    background: #ffffff;
    color: #0f5b2b;
    border-radius: 999px;
    padding: 12px 18px;
    font-size: 14px;
    font-weight: 600;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
    cursor: pointer;
    transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.view-more:hover {
    transform: translateY(-1px);
    border-color: #9fd5b1;
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.1);
}

@media (max-width: 992px) {
    .cards {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .gallery-section {
        padding: 0 16px;
    }

    .section-header {
        margin-bottom: 18px;
    }

    .cards {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .view-more {
        width: 100%;
        justify-content: center;
    }
}
</style>
